var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useMemo } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import AppBar from "../../Components/AppBar";
import useRetouchPictures from "@/react/Webshop/hooks/useRetouchPictures";
import useRoutes, { useHistory } from "@/react/Webshop/hooks/useRoutes";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import PictureList from "@/react/Webshop/Components/Retouch/PictureList";
import Container from "@mui/material/Container";
import LoadingButton from "@/react/components/LoadingButton";
import Box from "@mui/material/Box";
import useRetouch from "@/react/Webshop/hooks/useRetouch";
import { formatCurrency } from "@/react/utils";
import makeStyles from "@mui/styles/makeStyles";
import BottomBar from "../../Components/BottomBar";
const useStyles = makeStyles((theme) => ({
    totalPrice: {
        fontWeight: "bold",
        marginBottom: theme.spacing(1),
    },
}));
const ShoppingCartRetouch = () => {
    const { items } = useShoppingCart();
    const classes = useStyles();
    const { getRetouchPicturesByOrderLines } = useRetouch();
    const shoppingCartPictures = useMemo(() => {
        return getRetouchPicturesByOrderLines(items);
    }, [items]);
    const routes = useRoutes();
    const history = useHistory();
    const { handleToggleSubProduct, product, picturesSubProducts, isUpdatingCart, updateCart, totalPrice, numPicturesWithRetouch, } = useRetouchPictures(shoppingCartPictures);
    if (!product) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Retouch not available")));
    }
    const handleUpdateCart = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield updateCart();
            history.push(routes.shoppingcart.path);
        }
        catch (e) {
            console.error(e);
        }
    });
    return (React.createElement(MobilePage, { requireUser: true },
        React.createElement(AppBar, { disableBottomMargin: true }),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Retouch options")),
        React.createElement(Container, { maxWidth: "sm" },
            React.createElement("p", null,
                React.createElement(Trans, null, "Please make your selection of retouching options for the picture(s) you have added to your order")),
            React.createElement(PictureList, { pictures: shoppingCartPictures, product: product, picturesSubProducts: picturesSubProducts, handleToggleSubProduct: handleToggleSubProduct })),
        React.createElement(BottomBar, null,
            React.createElement(Container, null,
                React.createElement(Box, { display: "flex", justifyContent: "space-between", py: 1 },
                    React.createElement(Box, { display: "flex", alignItems: "center" },
                        React.createElement(Trans, null,
                            { numRetouchJobs: numPicturesWithRetouch },
                            " picture(s) for retouch")),
                    React.createElement(Box, { display: "flex", alignItems: "flex-end", flexDirection: "column" },
                        React.createElement("div", { className: classes.totalPrice },
                            React.createElement(Trans, null,
                                "Total: ",
                                { totalPrice: formatCurrency(totalPrice) })),
                        React.createElement(LoadingButton, { isLoading: isUpdatingCart, size: "large", onClick: handleUpdateCart },
                            React.createElement(Trans, null, "Next"))))))));
};
export default ShoppingCartRetouch;
